/* eslint-disable import/no-anonymous-default-export */
import {
  Table,
  Dropdown,
  Modal,
  Button,
  Tabs,
  Tab,
  Nav,
} from "react-bootstrap";
// import { SkillSearchInput } from "../../_uiComponents/Search/SkillSearchInput";
import { dateDiff } from "../../../../_helpers/dateFormatter";

export const SuggestedCandidates = ({
  assessmentData,
  isInvitationModal,
  isInviteSuccessModal,
  isCreateAssessmentModal,
  assignmentUserId,
  handleInvitationModal,
  handleInviteSuccessModal,
  handleCreateAssessmentModal,
  onAssignAssessmentClick,

  // candidateListData,
  suggestedCandidates,
  // showSearch,
  // searchInputRef2,
  handleAssignAssessmentModalOpen,
  handleAssignAssessmentModalClose,
  getShortlistedCount,
}) => {
  return (
    <div>
      <Table responsive="lg" className="custom-table mentor-table">
        <thead>
          <tr>
            <th>Candidate Name</th>
            <th>Skills</th>
            <th>Joined </th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {Array.isArray(suggestedCandidates) && suggestedCandidates.length ? (
            <>
              {Array.isArray(suggestedCandidates) &&
                suggestedCandidates.map((item) => (
                  <>
                    <tr>
                      <td className="align-middle">
                        <div className="d-flex align-items-center">
                          <div className="d-flex candidate-info flex-wrap">
                            <div className="candiate-img">
                              <img
                                src={
                                  item?.user_details &&
                                    item?.user_details?.user_meta_info &&
                                    item?.user_details?.user_meta_info
                                      ?.profile_image
                                    ? item?.user_details &&
                                    item?.user_details?.user_meta_info &&
                                    item?.user_details?.user_meta_info
                                      ?.profile_image
                                    : "/assets/images/user.png"
                                }
                                alt="candidate"
                              />
                            </div>

                            <div className="candiate-content">
                              <p className="font-weight-bold text-black mb-1">
                                {item?.user_details &&
                                  item?.user_details?.full_name}
                              </p>
                              <p className="mb-0">
                                {item?.user_details &&
                                  item?.user_details?.email}
                              </p>
                            </div>
                          </div>
                        </div>
                      </td>

                      <td className="align-middle">
                        <ul className="skill-list">
                          {item?.user_details &&
                            item?.user_details?.skills &&
                            item?.user_details &&
                            item?.user_details?.skills.map((item) => (
                              <li>{item}</li>
                            ))}
                        </ul>
                      </td>
                      <td className="align-middle">
                        {item?.user_details &&
                          item?.user_details?.created &&
                          dateDiff(
                            item?.user_details && item?.user_details?.created,
                            new Date()
                          )}{" "}
                        ago
                      </td>
                      <td className="align-middle">
                        <div className="d-flex align-items-center">
                          <button
                            className="border-0 bg-transparent text-nowrap text-primary font-weight-medium cursor-pointer"
                            onClick={() => handleInvitationModal(item?.user)}
                          >
                            Send Invite
                          </button>
                        </div>
                      </td>
                    </tr>
                  </>
                ))}
            </>
          ) : (
            <tr>
              <td colSpan={4}>
                <div className="font-bold text-center text-danger">No Candidates Found</div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      {/* <div className="d-flex p-3 border-top">
        <span>Page 1 of 10</span>
        <div className="d-flex ml-auto">
          <button className="bg-transparent py-2 border rounded-lg shadow-sm px-3 font-weight-semi ">
            Previous
          </button>
          <button className="bg-transparent rounded-lg ml-2 py-2 border shadow-sm px-3 font-weight-semi ">
            Next
          </button>
        </div>
      </div> */}

      <Modal
        show={isInvitationModal}
        centered
        size="md"
        onHide={handleInvitationModal}
        className="common-modal"
      >
        <Modal.Header closeButton className="bg-white">
          <Modal.Title>
            <h3>Send {assessmentData?.title} to Candidate</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-white d-flex align-items-center justify-content-between">
          <ul className="skill-list fs-smallest d-flex align-items-center flex-wrap">
            <span className="font-weight-medium fs-14">Skills:{" "}</span>
            {Array.isArray(assessmentData?.skills) && assessmentData.skills.map((skill) =>
              <li className="bg-grey px-2 py-1 rounded-lg border mx-1">{skill?.skill_id && skill.skill_id?.skill}</li>
            )}
          </ul>

          <button
            onClick={() =>
              onAssignAssessmentClick(assessmentData?.id, assignmentUserId)
            }
            className="btn text-primary mr-2"
          >
            Invite
          </button>
        </Modal.Body>
      </Modal>

      {/* <Modal show={isInvitationModal} centered onHide={handleInvitationModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            <strong>Send Invite to Candidate</strong>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-0 pt-0">
          <div className="new-listing-section bg-white">
            <Tab.Container id="left-tabs-example" defaultActiveKey="jobs">
              <div className="rounded-lg position-relative">
                <div className="d-flex align-items-center p-3 ">
                  <Nav variant="pills" className="tab-style-2">
                    <Nav.Item>
                      <Nav.Link eventKey="jobs">Jobs</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="assessments">Assessments</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
                <Tab.Content>
                  <Tab.Pane eventKey="jobs">
                    <Table
                      responsive="lg"
                      className="custom-table mentor-table"
                    >
                      <thead>
                        <tr>
                          <th>Job Title</th>
                          <th>Skills</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-middle">
                            <div className="d-flex align-items-center">
                              <div className="d-flex candidate-info">
                                <div className="candiate-img">
                                  <img
                                    src={"/assets/images/company-logo.png"}
                                    alt="candidate"
                                  />
                                </div>
                                <div className="candiate-content">
                                  <p className="font-weight-bold text-black mb-1">
                                    User Interface Designer
                                  </p>
                                  <p className="mb-0">Zydelo</p>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="align-middle">
                            <ul className="skill-list">
                              <li>Css</li>
                              <li>HTML</li>
                            </ul>
                          </td>
                          <td className="align-middle">
                            <button
                              onClick={() => handleInviteSuccessModal()}
                              className="action-btn mr-2"
                            >
                              Invite
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td className="align-middle">
                            <div className="d-flex align-items-center">
                              <div className="d-flex candidate-info">
                                <div className="candiate-img">
                                  <img
                                    src={"/assets/images/company-logo.png"}
                                    alt="candidate"
                                  />
                                </div>
                                <div className="candiate-content">
                                  <p className="font-weight-bold text-black mb-1">
                                    User Interface Designer
                                  </p>
                                  <p className="mb-0">Zydelo</p>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="align-middle">
                            <ul className="skill-list">
                              <li>Css</li>
                              <li>HTML</li>
                            </ul>
                          </td>
                          <td className="align-middle">
                            <button
                              onClick={() => handleInviteSuccessModal()}
                              className="action-btn mr-2"
                            >
                              Invite
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Tab.Pane>
                  <Tab.Pane eventKey="assessments">
                    <button
                      onClick={handleCreateAssessmentModal}
                      className="btn btn-primary py-1 position-absolute"
                      style={{ top: "15px", right: "10px" }}
                    >
                      Create
                    </button>
                    <Table
                      responsive="lg"
                      className="custom-table mentor-table"
                    >
                      <thead>
                        <tr>
                          <th>Assessment Title</th>
                          <th>Skills</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="align-middle">
                            <div className="d-flex align-items-center">
                              <div className="d-flex candidate-info">
                                <div className="candiate-content">
                                  <p className="font-weight-bold text-black mb-1">
                                    Python Kit
                                  </p>
                                  <p className="mb-0">Zydelo</p>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="align-middle">
                            <ul className="skill-list">
                              <li>Css</li>
                              <li>HTML</li>
                            </ul>
                          </td>
                          <td className="align-middle">
                            <button
                              onClick={() => handleInviteSuccessModal()}
                              className="action-btn mr-2"
                            >
                              Invite
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td className="align-middle">
                            <div className="d-flex align-items-center">
                              <div className="d-flex candidate-info">
                                <div className="candiate-content">
                                  <p className="font-weight-bold text-black mb-1">
                                    User Interface Designer
                                  </p>
                                  <p className="mb-0">Zydelo</p>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="align-middle">
                            <ul className="skill-list">
                              <li>Css</li>
                              <li>HTML</li>
                            </ul>
                          </td>
                          <td className="align-middle">
                            <button
                              onClick={() => handleInviteSuccessModal()}
                              className="action-btn mr-2"
                            >
                              Invite
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </Tab.Container>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            className="py-2"
            onClick={handleInvitationModal}
          >
            cancel
          </Button>
        </Modal.Footer>
      </Modal> */}

      {/* <Modal
        show={isInviteSuccessModal}
        centered
        onHide={handleInviteSuccessModal}
      >
        <Modal.Header
          closeButton
          className="justify-content-end border-bottom-0 pb-0"
        ></Modal.Header>
        <Modal.Body className="pt-0 mt-n1 fs-smallest">
          <div className="text-center">
            <div>
              <img src="/assets/images/success-icon.png" alt="success-icon" />
            </div>
            <h3>Assessment Invite Sent Successfully</h3>
            <p className="font-smallest">
              Your assessment invite has been successfullysent to the candidate.{" "}
            </p>
          </div>
          <div className="mb-3">
            <p className="font-weight-bold text-black mb-1">
              Product Designer{" "}
            </p>
            <p className="mb-0">Assessment Kit Title </p>
          </div>
          <div>
            <p className="font-weight-bold text-black mb-1">Skills</p>
            <ul className="font-smallest d-flex flex-wrap">
              <li className="mr-2 px-2 bg-grey rounded">Html</li>
              <li className="mr-2 px-2 bg-grey rounded">Css</li>
              <li className="mr-2 px-2 bg-grey rounded">React</li>
              <li className="mr-2 px-2 bg-grey rounded">Bootstrap</li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button
            variant=""
            className="py-2 bg-white border d-flex align-items-center"
            onClick={handleInviteSuccessModal}
          >
            <img
              src="/assets/images/copy-2.svg"
              className="mr-2"
              alt="copy-icon"
            />
            Copy Link
          </Button>
          <Button
            variant="primary"
            className="py-2"
            onClick={handleInviteSuccessModal}
          >
            Done
          </Button>
        </Modal.Footer>
      </Modal> */}

      {/* <Modal
        show={isCreateAssessmentModal}
        centered
        onHide={handleCreateAssessmentModal}
      >
        <Modal.Header closeButton>
          <strong>Create New Assessment</strong>
        </Modal.Header>
        <Modal.Body className="">
          <div className="form-group">
            <label htmlFor="" className="font-weight-medium mb-2">
              Assessment Kit Title <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter assessment kit title"
            />
          </div>
          <div className="form-group">
            <label className="font-weight-medium mb-2">
              Add Skills
              <span className="text-danger">* </span>
            </label>
            <div>
            <SkillSearchInput
                className="form-control mw-100"
                placeholder="Search Skill..."
                // onSearchSelect={(item) => onSkillSearch(item)}
                clearSearch={true}
                allowAdd={true}
                isSkillIdNeed={true}
              /> 
              <p className="text-grey-4 pt-2">Add 3-5 skills</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button
            variant=""
            className="py-2 bg-white border d-flex align-items-center"
            onClick={handleCreateAssessmentModal}
          >
            Back
          </Button>
          <Button
            variant="primary"
            className="py-2"
            onClick={handleCreateAssessmentModal}
          >
            Create & Send
          </Button>
        </Modal.Footer>
      </Modal> */}
    </div>
  );
};
